import { PAGE_REQUEST } from 'store/app/types';

import { types } from './actions';

const initialState = {
  isDeepCopyingQuoteItem: false,
  isOpen: false,
  quoteItemId: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case PAGE_REQUEST:
      return {
        ...initialState,
      };
    case types.DEEP_COPY_QUOTE_ITEM_REQUEST:
      return {
        ...state,
        isDeepCopyingQuoteItem: true,
      };
    case types.DEEP_COPY_QUOTE_ITEM_ERROR:
    case types.DEEP_COPY_QUOTE_ITEM_SUCCESS:
      return {
        ...state,
        isDeepCopyingQuoteItem: false,
      };
    case types.MODAL_OPEN:
      return {
        ...state,
        isOpen: true,
        quoteItemId: payload.quoteItemId,
      };
    case types.MODAL_CLOSE:
      return {
        ...state,
        isOpen: false,
        quoteItemId: null,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.quotes.quoteItemNav.deepCopyModal;

export const getIsDeepCopyingQuoteItem = (state) =>
  getScope(state).isDeepCopyingQuoteItem;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;

export default reducer;
